/**
 * Asynchronously renders a specific section of the page.
 * @param {Object} section - The section object containing the title and selector(s) for the section to be rendered.
 * @param {URL} url - An optional URL object to append query parameters for the fetch request.
 */
async function renderSection(section, url = null, type = null) {
  try {
    // Construct the URL for the fetch request, appending the section title and any additional query parameters.
    let response
    if (url) {
      if (type == null) {
        response = await fetch(
          `${window.location.pathname}?sections=${section.title}&${url.searchParams.toString()}`
        )
      } else if (type == 'search') {
        response = await fetch(`${url}&sections=${section.title}`)
      }
    } else {
      response = await fetch(
        `${window.location.pathname}?sections=${section.title}`
      )
    }

    if (response.ok) {
      // Parse the response as JSON.
      const data = await response.json()
      // Iterate over each selector specified for the section.
      section.selector.forEach((selector) => {
        const elements = [...document.querySelectorAll(`${selector}`)]
        let content
        // For each element matching the selector, find the corresponding content in the response.
        elements.forEach((element) => {
          if (element.dataset.id) {
            // If the element has a data-id, match it with the corresponding content in the response.
            content = new DOMParser()
              .parseFromString(data[section.title], 'text/html')
              .querySelector(`${selector}[data-id="${element.dataset.id}"]`)
          } else {
            // If there's no data-id, simply use the first matching element in the response.
            content = new DOMParser()
              .parseFromString(data[section.title], 'text/html')
              .querySelector(selector)
          }
          // If both the element and content are found, update the element's HTML with the content.
          if (element && content) {
            element.innerHTML = content.innerHTML
          }
        })
      })
    } else {
      // Log an error if the response is not OK.
      console.error('Error:', response)
      window.location.reload()
    }
  } catch (error) {
    // Catch and log any errors during the fetch operation.
    console.error('Error:', error)
    window.location.reload()
  }
}

/**
 * Asynchronously renders all specified sections of the page.
 * @param {Array} sections - An array of section objects to be rendered.
 * @param {URL} url - An optional URL object to append query parameters for the fetch requests.
 */
export async function renderAllSections(sections, url = null, type = null) {
  // Iterate over each section in the array and render it.
  for (const section of sections) {
    await renderSection(section, url, type)
  }
}
